import React, { useState, useEffect, useMemo } from "react";
import { Container, Row, Col, Button, ButtonGroup, Offcanvas, Modal, Alert, OverlayTrigger, Tooltip, Badge } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchMealPlansForMonth } from '../redux/slice/mealPlanDetailSlice'
import { addOrder, deleteOrder, fetchOrdersByMonth, updateOrder } from "../redux/slice/orderSlice";
import { formatDate } from "../utils/formatDate";
import '../assets/Calendar.css'
import { TakeawayDropdown } from "../components/TakeawayDropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight, faCircleCheck, faCircleInfo, faLock, faWarning } from "@fortawesome/free-solid-svg-icons";
import NotificationToast from "../components/Notifications";
import LoadingComponent from "../components/LoadingComponent";
import { calculateMealsByDate, calculateOrderedMeals } from "../helpers/calculateOrdersAndMealPlans";
import Cookies from 'js-cookie';
import RestrictedModeAlert from "../components/NotificationAlert";
import NotificationBlockWarning from "../components/NotificationBlockWarning";

const Calendar = () => {
  const dispatch = useDispatch()
  const today = new Date();
  const [showToast, setShowToast] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertVariant, setAlertVariant] = useState('info');
  const [currentYear, setCurrentYear] = useState(today.getFullYear());
  const [currentMonth, setCurrentMonth] = useState(today.getMonth());
  const [showOffcanvasMeals, setShowOffcanvasMeals] = useState(false);
  const [showOffcanvasOrder, setShowOffcanvasOrder] = useState(false);
  const [selectedMeals, setSelectedMeals] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalAction, setModalAction] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [getNewData, setNewData] = useState(0);
  const { details, status, error } = useSelector((state) => state.mealPlanDetails);
  const { orders, status: orderStatus, error: orderError } = useSelector((state) => state.orders);
  const tokenRefresh = Cookies.get('tokenRefresh');
  const isBlocked = JSON.parse(atob(tokenRefresh.split('.')[1])).block_user
  const isPayed = JSON.parse(atob(tokenRefresh.split('.')[1])).user_payed

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [order, setOrder] = useState({
    id: 0,
    mealPlan: 0,
    meal_one_id: 0,
    quantity_one: 1,
    meal_two_id: 0,
    quantity_two: 0,
    meal_three: 0,
    quantity_three_id: 0,
    bread: 0,
    grained_bread: 0,
    takeaway: ''
  })

  const handleCloseMeals = () => setShowOffcanvasMeals(false);
  const handleCloseOrder = () => setShowOffcanvasOrder(false);

  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = (action) => {
    setModalAction(action);
    setShowModal(true);
  };

  useEffect(() => {

    const fetchData = async () => {
      try {
        await dispatch(fetchMealPlansForMonth({ month: currentMonth + 1, year: currentYear }));
        await dispatch(fetchOrdersByMonth({ month: currentMonth + 1, year: currentYear }));

      } catch (error) {
        //console.error('Error fetching data:', error);

      }
    };

    fetchData();
  }, [dispatch, currentYear, currentMonth, getNewData]);

  const mealsByDate = useMemo(() => calculateMealsByDate(details), [details]);
  const orderedMeals = useMemo(() => calculateOrderedMeals(orders), [orders]);

  const handleShowMeals = (date, meals) => {
    setSelectedMeals(meals);
    setOrder({
      mealPlan: meals[0].id,
      meal_one_id: meals[0].meal_one,
      quantity_one: 0,
      meal_two_id: meals[0].meal_two,
      quantity_two: 0,
      meal_three_id: meals[0].meal_three,
      quantity_three: 0,
      bread: 0,
      grained_bread: 0,
      takeaway: ''
    })

    setShowOffcanvasMeals(true);
  };
  const handleShowOrder = (date, order, mealPlan) => {
    setSelectedMeals(mealPlan);
    setSelectedOrder(order);
    setOrder({
      id: order[0].id,
      mealPlan: order[0].meal_plan_detail,
      meal_one_id: order[0].meal_one.id,
      quantity_one: order[0].quantity_one,
      meal_two_id: order[0].meal_two.id,
      quantity_two: order[0].quantity_two,
      meal_three_id: order[0].meal_three.id,
      quantity_three: order[0].quantity_three,
      bread: order[0].bread_quantity,
      grained_bread: order[0].grained_bread_quantity,
      takeaway: order[0].takeaway
    })
    setShowOffcanvasOrder(true);
  };
  const increaseQuantity = (mealKey, totalOrder) => {
    setOrder((prevOrder) => {
      const totalQuantity = prevOrder.quantity_one + prevOrder.quantity_two + prevOrder.quantity_three;
      // Αν το mealKey είναι 'bread', ελέγχουμε ξεχωριστά το εύρος από 0 έως 15
      if (mealKey === "bread") {
        return {
          ...prevOrder,
          bread: prevOrder.bread < 6 ? prevOrder.bread + 1 : 6
        };
      }
      if (mealKey === "grained_bread") {
        return {
          ...prevOrder,
          grained_bread: prevOrder.grained_bread < 6 ? prevOrder.grained_bread + 1 : 6
        };
      }
      if (totalQuantity < totalOrder) {

        return {
          ...prevOrder,
          [mealKey]: prevOrder[mealKey] + 1
        };
      }

      return prevOrder;
    });
  };

  const decreaseQuantity = (mealKey) => {
    setOrder((prevOrder) => {
      const totalQuantity = prevOrder.quantity_one + prevOrder.quantity_two + prevOrder.quantity_three;

      // Αν το mealKey είναι 'bread', ελέγχουμε ξεχωριστά το εύρος από 0 έως 15
      if (mealKey === "bread") {
        return {
          ...prevOrder,
          bread: prevOrder.bread > 0 ? prevOrder.bread - 1 : 0
        };
      }

      if (mealKey === "grained_bread") {
        return {
          ...prevOrder,
          grained_bread: prevOrder.grained_bread > 0 ? prevOrder.grained_bread - 1 : 0
        };
      }

      // Έλεγχος: Αν το σύνολο των ποσοτήτων (εκτός του bread) είναι >= 2, επιτρέπουμε τη μείωση
      if (totalQuantity > 1) {
        return {
          ...prevOrder,
          [mealKey]: prevOrder[mealKey] > 0 ? prevOrder[mealKey] - 1 : 0
        };
      }

      // Αν το σύνολο είναι < 2, επιστρέφουμε το προηγούμενο state χωρίς αλλαγές
      return prevOrder;
    });
  };



  const handleOrder = async () => {
    const orderData = {
      "meal_plan_detail": order.mealPlan,
      "meal_one_id": order.meal_one_id,
      "quantity_one": order.quantity_one,
      "meal_two_id": order.meal_two_id,
      "quantity_two": order.quantity_two,
      "meal_three_id": order.meal_three_id,
      "quantity_three": order.quantity_three,
      "bread_quantity": order.bread,
      "grained_bread_quantity": order.grained_bread,
      "takeaway": order.takeaway
    }
    try {
      await dispatch(addOrder(orderData)).unwrap()
      setAlertMessage(`Η παραγγελία για την ημερομηνία ${formatDate(selectedMeals[0]?.date)} ολοκληρώθηκε με επιτυχία.`);
      setAlertVariant('success');
      setShowToast(true);
      setNewData(getNewData + 1)
    } catch (err) {
      setAlertMessage(err || 'Αποτυχία προσθήκης παραγγελίας.');
      setAlertVariant('danger');
      setShowToast(true);
    }
  }
  const handleOrderDelete = async () => {

    try {
      await dispatch(deleteOrder(order.id)).unwrap()
      setAlertMessage('Η παραγγελία διαγράφηκε με επιτυχία.');
      setAlertVariant('success');
      setShowToast(true);
      setNewData(getNewData + 1)
    } catch (err) {
      setAlertMessage('Αποτυχία διαγραφής παραγγελίας.');
      setAlertVariant('danger');
      setShowToast(true);
    }
  }
  const handleOrderUpdate = async () => {
    const orderData = {
      "meal_plan_detail": order.mealPlan,
      "meal_one_id": order.meal_one_id,
      "quantity_one": order.quantity_one,
      "meal_two_id": order.meal_two_id,
      "quantity_two": order.quantity_two,
      "meal_three_id": order.meal_three_id,
      "quantity_three": order.quantity_three,
      "bread_quantity": order.bread,
      "grained_bread_quantity": order.grained_bread,
      "takeaway": order.takeaway
    }

    try {
      await dispatch(updateOrder({ orderId: order.id, orderData: orderData })).unwrap()
      setAlertMessage(`Η παραγγελία για την ημερομηνία ${formatDate(selectedMeals[0]?.date)} ενημερώθηκε με επιτυχία.`);
      setAlertVariant('success');
      setShowToast(true);
      setNewData(getNewData + 1)
    } catch (err) {
      setAlertMessage(err || 'Αποτυχία ενημέρωσης παραγγελίας.');
      setAlertVariant('danger');
      setShowToast(true);
    }
  }

  const goToNextMonth = () => {
    if (currentMonth === 11) {
      setCurrentMonth(0);
      setCurrentYear(currentYear + 1);
    } else {
      setCurrentMonth(currentMonth + 1);
    }
  };

  const goToPreviousMonth = () => {
    if (currentMonth === 0) {
      setCurrentMonth(11);
      setCurrentYear(currentYear - 1);
    } else {
      setCurrentMonth(currentMonth - 1);
    }
  };

  // Παίρνουμε την πρώτη ημέρα του μήνα
  const firstDayOfMonth = new Date(currentYear, currentMonth, 1).getDay();

  // Παίρνουμε τον αριθμό των ημερών του μήνα
  const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();

  // Παίρνουμε την τελευταία ημέρα του μήνα
  const lastDayOfMonth = new Date(currentYear, currentMonth, daysInMonth).getDay();

  // Δημιουργούμε ένα array με τις ημέρες του μήνα
  const daysArray = [...Array(daysInMonth).keys()].map((i) => i + 1);

  // Δημιουργούμε τα κελιά πριν την πρώτη ημέρα του μήνα για σωστή ευθυγράμμιση
  const emptyCellsBefore = [...Array(firstDayOfMonth === 0 ? 6 : firstDayOfMonth - 1).keys()];

  // Δημιουργούμε τα κελιά μετά την τελευταία ημέρα του μήνα για σωστή ευθυγράμμιση
  const emptyCellsAfter = [...Array(lastDayOfMonth === 0 ? 0 : 7 - lastDayOfMonth).keys()];

  // Χωρίζουμε τις ημέρες σε εβδομάδες
  const calendarRows = [];
  let weekDays = [
    ...emptyCellsBefore.map(() => null),
    ...daysArray,
    ...emptyCellsAfter.map(() => null),
  ];
  while (weekDays.length) {
    calendarRows.push(weekDays.splice(0, 7));
  }

  // Δημιουργία του μήνα ως κείμενο με βάση το currentMonth
  const monthNames = [
    "Ιανουάριος",
    "Φεβρουάριος",
    "Μάρτιος",
    "Απρίλιος",
    "Μάιος",
    "Ιούνιος",
    "Ιούλιος",
    "Αύγουστος",
    "Σεπτέμβριος",
    "Οκτώβριος",
    "Νοέμβριος",
    "Δεκέμβριος",
  ];
  const currentMonthName = monthNames[currentMonth];

  return (
    <>
      {status === 'loading' && <LoadingComponent />}
      {orderStatus === 'loading' && <LoadingComponent />}
      {status === 'failed' && <Alert variant="danger">{error}</Alert>}
      {orderStatus === 'failed' && <Alert variant="danger">{orderError}</Alert>}
      {(status === 'succeeded' && orderStatus === 'succeeded') && (<Container>
        <h3 className="text-center my-4" style={{ color: 'black' }}>Μηνιαίο Μενού Γευμάτων</h3>
        {isBlocked && <RestrictedModeAlert />}
        {(!isPayed && !isBlocked) && <NotificationBlockWarning />}
        <Row className="text-center mb-2">
          <Col xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
            <div className="month-container" style={{ display: 'flex', alignItems: 'center' }}>
              <button className="month-item" onClick={goToPreviousMonth}>
                <FontAwesomeIcon icon={faArrowLeft} />
              </button>
              <div className="month-toggle">
                {currentMonthName}, {currentYear}
              </div>
              <button className="month-item" onClick={goToNextMonth}>
                <FontAwesomeIcon icon={faArrowRight} />
              </button>
            </div>
          </Col>
        </Row>
        {!isMobile && <Row className="text-center">
          <Col sm={2} style={{ fontWeight: "600", marginRight: "0px", marginBottom: "2px", height: "50px", color: 'black' }}>
            ΔΕΥ
          </Col>
          <Col sm={2} style={{ fontWeight: "600", marginRight: "0px", marginBottom: "2px", height: "50px", color: 'black' }}>
            ΤΡΙ
          </Col>
          <Col sm={2} style={{ fontWeight: "600", marginRight: "0px", marginBottom: "2px", height: "50px", color: 'black' }}>
            ΤΕΤ
          </Col>
          <Col sm={2} style={{ fontWeight: "600", marginRight: "0px", marginBottom: "2px", height: "50px", color: 'black' }}>
            ΠΕΜ
          </Col>
          <Col sm={2} style={{ fontWeight: "600", marginRight: "0px", marginBottom: "2px", height: "50px", color: 'black' }}>
            ΠΑΡ
          </Col>
          <Col sm={1} style={{ fontWeight: "600", marginRight: "0px", marginBottom: "2px", height: "50px", color: 'black' }}>
            ΣΑΒ
          </Col>
          <Col sm={1} style={{ fontWeight: "600", marginRight: "0px", marginBottom: "2px", height: "50px", color: 'black' }}>
            ΚΥΡ
          </Col>
        </Row>}
        {calendarRows.map((week, index) => (
          <Row key={`${week}${index}`} className="text-right" >

            {week.map((day, idx) => {
              // Δημιουργία της σωστής μορφής της ημερομηνίας
              const date = `${currentYear}-${String(currentMonth + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
              const mealsForDate = mealsByDate[date];
              const isLocked = mealsForDate ? mealsForDate[0].lock : false
              const isHoliday = mealsForDate ? mealsForDate[0].holiday : false
              const ordersForDate = orderedMeals[date]
              const isToday =
                day === today.getDate() &&
                currentMonth === today.getMonth() &&
                currentYear === today.getFullYear();
              // Προσθέτουμε +3 ημέρες (ετσι ζητηθηκε)
              const todayPlusThree = new Date(today);
              todayPlusThree.setDate(today.getDate() + 3);
              // console.log(todayPlusThree)
              const isPastDatePlusThree = new Date(date) < todayPlusThree;
              // console.log(isPastDatePlusThree)
              // const isPastDate = new Date(date) < today;
              const isCurrentMonth = new Date(date).getMonth() === currentMonth;
              const isWeekend = (idx === 5 || idx === 6);

              return (
                <Col
                  md={(idx === 5 || idx === 6) ? 1 : 2}
                  key={`${index}-${idx}`}
                  style={{
                    display: ((isMobile && day) === null) && "none",
                    marginBottom: "2px",
                    height: "150px",
                    borderRight: '1px solid white',
                    // backgroundColor: (isPastDatePlusThree || isLocked || isHoliday) ? "#f7cecf" : ordersForDate ? '#e1ecf6' : mealsForDate ? "#daeed7" : isCurrentMonth ? "#e5e5e5" : 'white',
                    backgroundColor: (isPastDatePlusThree || isLocked || isHoliday) ? "#E8ADB6" : mealsForDate ? "#c4e9da" : (isCurrentMonth || (isCurrentMonth && isWeekend)) ? "#c4e9da" : 'white',
                    color: (isPastDatePlusThree || isLocked || isWeekend) ? "#616161" : "#494848",
                    textAlign: "end",
                    cursor: (mealsForDate || ordersForDate) && !isPastDatePlusThree && !isLocked && !isBlocked ? "pointer" : "not-allowed",
                    pointerEvents: (isHoliday || isPastDatePlusThree || isLocked || !isCurrentMonth) ? "none" : "auto",
                    '--hover-opacity': isCurrentMonth ? "0.0" : "1.0",
                    '--hover-background-color': isCurrentMonth ? 'darkgray' : 'white',
                  }}
                  className={`col-hover ${isToday ? "bg-secondary text-white-50" : ""}`}
                  onClick={() => !isBlocked ? (ordersForDate && (!isHoliday && !isLocked && !isPastDatePlusThree) ? handleShowOrder(date, ordersForDate, mealsForDate) : ((mealsForDate && !isHoliday && !isLocked && !isPastDatePlusThree) && handleShowMeals(date, mealsForDate))) : {}}
                >
                  <div key={`name-${index}-${idx}`} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
                      {(!isHoliday && ordersForDate) && <FontAwesomeIcon style={{ color: `${isToday ? 'lightgray' : (isLocked || isPastDatePlusThree) ? 'darkgreen' : 'green'}`, }} icon={faCircleCheck} />}
                      {(!isHoliday && !ordersForDate && mealsForDate) &&
                        <div style={{ border: '2px solid gray', borderRadius: '50px', width: '15px', height: '15px' }}></div>
                      }
                      {(!isHoliday && ordersForDate) && (
                        <Badge bg="success" className="ms-1">{ordersForDate?.[0]?.takeaway ? `${ordersForDate[0].takeaway.trim().charAt(0)}-${ordersForDate[0].takeaway.trim().slice(-4).replace(/\s+/g, '')}` : '.'}</Badge>
                      )}

                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      {((isPastDatePlusThree ) || isLocked || isHoliday) && <FontAwesomeIcon style={{ color: `${isToday ? 'lightgray' : 'gray'}`, marginRight: '4px' }} icon={faLock} />}
                      {!isMobile && (day || "")}{isMobile && (formatDate(date) || "")}
                    </div>
                  </div>
                  <div style={{ textAlign: "left", fontSize: "12px", marginTop: "5px", color: '' }}>
                    {((isHoliday) &&
                      <div style={{ textAlign: 'center' }}>
                        <span><strong>Αργία</strong></span>
                      </div>
                    )
                    }
                    {!isHoliday && !ordersForDate && mealsForDate &&
                      mealsForDate.map((meal, mealIndex) => (
                        <div key={`meal-${date}-${mealIndex}`}>
                          <div>• {meal?.meal_one_name}</div>
                          <div>• {meal?.meal_two_name}</div>
                          <div>• {meal?.meal_three_name}</div>
                        </div>
                      ))}
                    {!isHoliday && ordersForDate &&
                      ordersForDate.map((meal, orderIndex) => (
                        <div key={`order-${date}-${orderIndex}`}>
                          <div>• {meal?.meal_one?.name}{': '}{meal?.quantity_one}</div>
                          {meal?.meal_two && <div>• {meal?.meal_two?.name}{': '}{meal?.quantity_two}</div>}
                          {meal?.meal_three && <div>• {meal?.meal_three?.name}{': '}{meal?.quantity_three}</div>}
                        </div>
                      ))}
                  </div>
                </Col>

              );
            })}
          </Row>
        ))}

        <Offcanvas show={showOffcanvasMeals} onHide={() => setShowOffcanvasMeals(false)} placement="end">
          <Offcanvas.Header style={{ display: 'flex', flexDirection: 'column' }} closeButton>
            <Offcanvas.Title>Προσθήκη Παραγγελίας</Offcanvas.Title>
            <span>{formatDate(selectedMeals[0]?.date)}</span>
          </Offcanvas.Header>
          <Offcanvas.Body>
            {(selectedMeals && selectedMeals.length > 0 && (selectedMeals[0]?.meal_one_available + selectedMeals[0]?.meal_two_available + selectedMeals[0]?.meal_three_available >= 1)) ? (
              selectedMeals.map((meal, mealIndex) => (
                <div key={`meals-${mealIndex}`} style={{ marginBottom: "20px" }}>

                  {meal?.meal_one_available === 0 && <p style={{ color: 'gray', textAlign: 'start', fontSize: '12px', marginBottom: '-2px', marginLeft: '5px' }}>
                    <FontAwesomeIcon icon={faWarning} size="sm" color="orange" />
                    {' '}Το γεύμα δεν είναι  διαθέσιμο
                  </p>}
                  <div className="btn-hover">
                    <Col className="btn-group-container">
                      <h5 style={{ fontWeight: '500', width: '60%', color: `${meal?.meal_one_available === 0 && 'gray'}` }} >{meal?.meal_one_name}
                        {meal?.meal_one_description !== '-' && <OverlayTrigger overlay={<Tooltip placement="top" className="in" id="tooltip-top">
                          {'ΑΛΛΕΡΓΙΟΓΟΝΑ: '}{meal?.meal_one_description}
                        </Tooltip>
                        }>
                          <FontAwesomeIcon className="fa-icons" icon={faCircleInfo} style={{ cursor: 'pointer', marginLeft: '10px' }} />
                        </OverlayTrigger>}
                      </h5>
                      <ButtonGroup className="btn-container">
                        <Button className="btn-order" variant="primary" disabled={order?.quantity_one === 0} onClick={() => decreaseQuantity("quantity_one")}>
                          <span style={{ fontWeight: '600' }}>-</span>
                        </Button>
                        <Button className="btn-order" variant="outline-dark" ><span style={{ fontWeight: '400' }}>{order?.quantity_one}</span></Button>
                        <Button className="btn-order" variant="primary" disabled={(order?.quantity_one >= meal?.meal_one_available)} onClick={() => increaseQuantity("quantity_one", meal?.total_meals_order_limit)}>
                          <span style={{ fontWeight: '600' }}>+</span>
                        </Button>
                      </ButtonGroup>
                    </Col>

                  </div>
                  {meal?.meal_two_available === 0 && <p style={{ color: 'gray', textAlign: 'start', fontSize: '12px', marginBottom: '-2px', marginLeft: '5px' }}>
                    <FontAwesomeIcon icon={faWarning} size="sm" color="orange" />
                    {' '}Το γεύμα δεν είναι  διαθέσιμο
                  </p>}
                  <div className="btn-hover">
                    <Col className="btn-group-container">
                      <h5 style={{ fontWeight: '500', width: '60%', color: `${meal?.meal_two_available === 0 && 'gray'}` }} >{meal?.meal_two_name}
                        {meal?.meal_two_description !== '-' && <OverlayTrigger overlay={<Tooltip placement="top" className="in" id="tooltip-top">
                          {'ΑΛΛΕΡΓΙΟΓΟΝΑ: '}{meal?.meal_two_description}
                        </Tooltip>
                        }>
                          <FontAwesomeIcon className="fa-icons" icon={faCircleInfo} color='orange' style={{ cursor: 'pointer', marginLeft: '10px' }} />
                        </OverlayTrigger>}
                      </h5>

                      <ButtonGroup className="btn-container">
                        <Button className="btn-order" variant="primary" disabled={order?.quantity_two === 0} onClick={() => decreaseQuantity("quantity_two")}>
                          <span style={{ fontWeight: '600' }}>-</span>
                        </Button>
                        <Button className="btn-order" variant="outline-dark" ><span style={{ fontWeight: '400' }}>{order?.quantity_two}</span></Button>
                        <Button className="btn-order" variant="primary" disabled={(order?.quantity_two >= meal?.meal_two_available)} onClick={() => increaseQuantity("quantity_two", meal?.total_meals_order_limit)}>
                          <span style={{ fontWeight: '600' }}>+</span>
                        </Button>
                      </ButtonGroup>
                    </Col>

                  </div>

                  {meal?.meal_three_available === 0 && <p style={{ color: 'gray', textAlign: 'start', fontSize: '12px', marginBottom: '-2px', marginLeft: '5px' }}>
                    <FontAwesomeIcon icon={faWarning} size="sm" color="orange" />
                    {' '}Το γεύμα δεν είναι  διαθέσιμο
                  </p>}
                  <div className="btn-hover">
                    <Col className="btn-group-container">
                      <h5 style={{ fontWeight: '500', width: '60%', color: `${meal?.meal_three_available === 0 && 'gray'}` }} >{meal?.meal_three_name}
                        {meal?.meal_three_description !== '-' && <OverlayTrigger overlay={<Tooltip placement="top" className="in" id="tooltip-top">
                          {'ΑΛΛΕΡΓΙΟΓΟΝΑ: '}{meal?.meal_three_description}
                        </Tooltip>
                        }>
                          <FontAwesomeIcon className="fa-icons" icon={faCircleInfo} color='orange' style={{ cursor: 'pointer', marginLeft: '10px' }} />
                        </OverlayTrigger>}
                      </h5>
                      <ButtonGroup className="btn-container" >
                        <Button className="btn-order" variant="primary" disabled={order?.quantity_three === 0} onClick={() => decreaseQuantity("quantity_three")}>
                          <span style={{ fontWeight: '600' }}>-</span>
                        </Button>
                        <Button className="btn-order" variant="outline-dark" ><span style={{ fontWeight: '400' }}>{order?.quantity_three}</span></Button>
                        <Button className="btn-order" variant="primary" disabled={(order?.quantity_three >= meal?.meal_three_available)} onClick={() => increaseQuantity("quantity_three", meal?.total_meals_order_limit)}>
                          <span style={{ fontWeight: '600' }}>+</span>
                        </Button>
                      </ButtonGroup>
                    </Col>
                  </div>

                  <div className="btn-hover">
                    <Col className="btn-group-container">
                      <h5 style={{ fontWeight: '500', width: '60%' }} >Άρτος Λευκός</h5>
                      <ButtonGroup className="btn-container">
                        <Button className="btn-order" variant="primary" disabled={order?.bread === 0} onClick={() => decreaseQuantity("bread")}>
                          <span style={{ fontWeight: '600' }}>-</span>
                        </Button>
                        <Button className="btn-order" variant="outline-dark"><span style={{ fontWeight: '400' }}>{order.bread}</span></Button>
                        <Button className="btn-order" variant="primary" onClick={() => increaseQuantity("bread")}>
                          <span style={{ fontWeight: '600' }}>+</span>
                        </Button>
                      </ButtonGroup>
                    </Col>
                  </div>

                  <div className="btn-hover">
                    <Col className="btn-group-container">
                      <h5 style={{ fontWeight: '500', width: '60%' }} >Άρτος Ολικής</h5>
                      <ButtonGroup className="btn-container">
                        <Button className="btn-order" variant="primary" disabled={order?.grained_bread === 0} onClick={() => decreaseQuantity("grained_bread")}>
                          <span style={{ fontWeight: '600' }}>-</span>
                        </Button>
                        <Button className="btn-order" variant="outline-dark"><span style={{ fontWeight: '400' }}>{order.grained_bread}</span></Button>
                        <Button className="btn-order" variant="primary" onClick={() => increaseQuantity("grained_bread")}>
                          <span style={{ fontWeight: '600' }}>+</span>
                        </Button>
                      </ButtonGroup>
                    </Col>
                  </div>

                  <div className="btn-hover">
                    <Col className="btn-group-container">
                      <h5 style={{ fontWeight: '500', width: '60%' }} >Παραλαβή</h5>
                      <TakeawayDropdown order={order} setOrder={setOrder} />
                    </Col>
                  </div>
                  <Button variant="success" disabled={order?.takeaway === '' || (order?.quantity_one + order?.quantity_two + order?.quantity_three + order.grained_bread + order.bread === 0)} onClick={() => handleShowModal('add')} style={{ paddingLeft: '20px', paddingRight: '20px' }}><span style={{ fontWeight: 700 }}>Παραγγελία</span></Button>
                </div>
              ))
            ) : (
              <>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                  <FontAwesomeIcon icon={faWarning} size="2x" color="orange" />
                  <h4 style={{ textAlign: 'center' }}>Τα γεύματα έχουν εξαντληθεί</h4>
                  <p style={{ color: 'gray', textAlign: 'center', marginTop: '10px' }}>
                    Τα παρακάτω γεύματα δεν είναι  διαθέσιμα
                  </p>
                </div>
                <div className="btn-hover">
                  <Col className="btn-group-container">
                    <h5 style={{ fontWeight: '500', color: 'GrayText' }} >{selectedMeals[0]?.meal_one_name}{': 0'}</h5>
                  </Col>
                </div>
                <div className="btn-hover">
                  <Col className="btn-group-container">
                    <h5 style={{ fontWeight: '500', color: 'GrayText' }} >{selectedMeals[0]?.meal_two_name} {': 0'}</h5>
                  </Col>
                </div>
                <div className="btn-hover">
                  <Col className="btn-group-container">
                    <h5 style={{ fontWeight: '500', color: 'GrayText' }} >{selectedMeals[0]?.meal_three_name}{': 0'}</h5>
                  </Col>
                </div>
              </>
            )}
          </Offcanvas.Body>
        </Offcanvas>

        <Offcanvas show={showOffcanvasOrder} onHide={() => setShowOffcanvasOrder(false)} placement="end">
          <Offcanvas.Header style={{ display: 'flex', flexDirection: 'column' }} closeButton>
            <Offcanvas.Title>Επεξεργασία Παραγγελίας</Offcanvas.Title>
            <span>{formatDate(selectedMeals[0]?.date)}</span>
          </Offcanvas.Header>
          <Offcanvas.Body>
            {selectedOrder && selectedOrder.length > 0 ? (
              selectedOrder.map((meal, orderIndex) => (
                <div key={`orders-${orderIndex}`} style={{ marginBottom: "20px" }}>

                  <div className="btn-hover">
                    <Col className="btn-group-container">
                      <h5 style={{ fontWeight: '500', width: '60%' }} >{meal?.meal_one?.name}
                        {meal?.meal_one?.description !== '-' && <OverlayTrigger overlay={<Tooltip placement="top" className="in" id="tooltip-top">
                          {'ΑΛΛΕΡΓΙΟΓΟΝΑ: '}{meal?.meal_one?.description}
                        </Tooltip>
                        }>
                          <FontAwesomeIcon className="fa-icons" icon={faCircleInfo} style={{ cursor: 'pointer', marginLeft: '10px' }} />
                        </OverlayTrigger>}
                      </h5>
                      <ButtonGroup className="btn-container">
                        <Button className="btn-order" variant="primary" disabled={order?.quantity_one === 0} onClick={() => decreaseQuantity("quantity_one")}>
                          <span style={{ fontWeight: '600' }}>-</span>
                        </Button>
                        <Button className="btn-order" variant="outline-dark"><span style={{ fontWeight: '400' }}>{order?.quantity_one}</span></Button>
                        <Button className="btn-order" variant="primary" disabled={order?.quantity_one >= (meal?.quantity_one + selectedMeals[0]?.meal_one_available)} onClick={() => increaseQuantity("quantity_one", selectedMeals[0]?.total_meals_order_limit)}>
                          <span style={{ fontWeight: '600' }}>+</span>
                        </Button>
                      </ButtonGroup>
                    </Col>
                  </div>

                  <div className="btn-hover">
                    <Col className="btn-group-container">
                      <h5 style={{ fontWeight: '500', width: '60%', }} >{meal?.meal_two?.name}
                        {meal?.meal_two?.description !== '-' && <OverlayTrigger overlay={<Tooltip placement="top" className="in" id="tooltip-top">
                          {'ΑΛΛΕΡΓΙΟΓΟΝΑ: '}{meal?.meal_two?.description}
                        </Tooltip>
                        }>
                          <FontAwesomeIcon className="fa-icons" icon={faCircleInfo} color='orange' style={{ cursor: 'pointer', marginLeft: '10px' }} />
                        </OverlayTrigger>}
                      </h5>
                      <ButtonGroup className="btn-container">
                        <Button className="btn-order" variant="primary" disabled={order?.quantity_two === 0} onClick={() => decreaseQuantity("quantity_two")}>
                          <span style={{ fontWeight: '600' }}>-</span>
                        </Button>
                        <Button className="btn-order" variant="outline-dark" ><span style={{ fontWeight: '400' }}>{order?.quantity_two}</span></Button>
                        <Button className="btn-order" variant="primary" disabled={order?.quantity_two >= (meal?.quantity_two + selectedMeals[0]?.meal_two_available)} onClick={() => increaseQuantity("quantity_two", selectedMeals[0]?.total_meals_order_limit)}>
                          <span style={{ fontWeight: '600' }}>+</span>
                        </Button>
                      </ButtonGroup>
                    </Col>
                  </div>

                  <div className="btn-hover">
                    <Col className="btn-group-container">
                      <h5 style={{ fontWeight: '500', width: '60%' }} >{meal?.meal_three?.name}
                        {meal?.meal_three?.description !== '-' && <OverlayTrigger overlay={<Tooltip placement="top" className="in" id="tooltip-top">
                          {'ΑΛΛΕΡΓΙΟΓΟΝΑ: '}{meal?.meal_three?.description}
                        </Tooltip>
                        }>
                          <FontAwesomeIcon className="fa-icons" icon={faCircleInfo} color='orange' style={{ cursor: 'pointer', marginLeft: '10px' }} />
                        </OverlayTrigger>}
                      </h5>
                      <ButtonGroup className="btn-container">
                        <Button className="btn-order" variant="primary" disabled={order?.quantity_three === 0} onClick={() => decreaseQuantity("quantity_three")}>
                          <span style={{ fontWeight: '600' }}>-</span>
                        </Button>
                        <Button className="btn-order" variant="outline-dark" ><span style={{ fontWeight: '400' }}>{order?.quantity_three}</span></Button>
                        <Button className="btn-order" variant="primary" disabled={order?.quantity_three >= (meal?.quantity_three + selectedMeals[0]?.meal_three_available)} onClick={() => increaseQuantity("quantity_three", selectedMeals[0]?.total_meals_order_limit)}>
                          <span style={{ fontWeight: '600' }}>+</span>
                        </Button>
                      </ButtonGroup>
                    </Col>
                  </div>

                  <div className="btn-hover">
                    <Col className="btn-group-container">
                      <h5 style={{ fontWeight: '500', width: '60%' }} >Άρτος Λευκός</h5>
                      <ButtonGroup className="btn-container">
                        <Button className="btn-order" variant="primary" disabled={order?.bread === 0} onClick={() => decreaseQuantity("bread")}>
                          <span style={{ fontWeight: '600' }}>-</span>
                        </Button>
                        <Button className="btn-order" variant="outline-dark"><span style={{ fontWeight: '400' }}>{order?.bread}</span></Button>
                        <Button className="btn-order" variant="primary" onClick={() => increaseQuantity("bread")}>
                          <span style={{ fontWeight: '600' }}>+</span>
                        </Button>
                      </ButtonGroup>
                    </Col>
                  </div>

                  <div className="btn-hover">
                    <Col className="btn-group-container">
                      <h5 style={{ fontWeight: '500', width: '60%' }} >Άρτος Ολικής</h5>
                      <ButtonGroup className="btn-container">
                        <Button className="btn-order" variant="primary" disabled={order?.grained_bread === 0} onClick={() => decreaseQuantity("grained_bread")}>
                          <span style={{ fontWeight: '600' }}>-</span>
                        </Button>
                        <Button className="btn-order" variant="outline-dark"><span style={{ fontWeight: '400' }}>{order?.grained_bread}</span></Button>
                        <Button className="btn-order" variant="primary" onClick={() => increaseQuantity("grained_bread")}>
                          <span style={{ fontWeight: '600' }}>+</span>
                        </Button>
                      </ButtonGroup>
                    </Col>
                  </div>

                  <div className="btn-hover">
                    <Col className="btn-group-container">
                      <h5 style={{ fontWeight: '500', width: '60%' }} >Παραλαβή</h5>
                      <TakeawayDropdown order={order} setOrder={setOrder} />
                    </Col>
                  </div>

                  <p></p>
                  <Button variant="success" onClick={() => handleShowModal('update')} style={{ marginRight: '10px', paddingLeft: '20px', paddingRight: '20px' }}><span style={{ fontWeight: 700 }}>Ενημέρωση</span></Button>
                  <Button variant="danger" onClick={() => handleShowModal('delete')} style={{ paddingLeft: '20px', paddingRight: '20px' }}><span style={{ fontWeight: 700 }}>Διαγραφή</span></Button>
                </div>
              ))
            ) : (
              <></>
            )}
          </Offcanvas.Body>
        </Offcanvas>

        <Modal
          show={showModal}
          onHide={handleCloseModal}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {modalAction === "delete" && "Διαγραφή Παραγγελίας"}
              {modalAction === "update" && "Ενημέρωση Παραγγελίας"}
              {modalAction === "add" && "Προσθήκη Παραγγελίας"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Είστε σίγουροι ότι θέλετε να {modalAction === "delete" ? "διαγράψετε" : modalAction === "update" ? "ενημερώσετε" : "προσθέσετε"} αυτή την παραγγελία;
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" className="modal-btn" onClick={() => {
              if (modalAction === "delete") {
                handleOrderDelete()
              } else if (modalAction === "update") {
                handleOrderUpdate()
              } else if (modalAction === "add") {
                handleOrder()
              }
              handleCloseModal();
              handleCloseMeals();
              handleCloseOrder();
            }}>
              Ναι
            </Button>
            <Button variant="danger" className="modal-btn" onClick={handleCloseModal}>Όχι</Button>
          </Modal.Footer>
        </Modal>

        <NotificationToast
          show={showToast}
          onClose={() => setShowToast(false)}
          message={alertMessage}
          variant={alertVariant}
        />

      </Container>)}
    </>
  );
};

export default Calendar;
